/* src/app/order/pages/order-quick/order-quick.component.scss */
/*# sourceMappingURL=order-quick.component.css.map */
